function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Modal, Typography } from '@applyboard/ui-components';
import LoadingOverlay from "../../../components/core/ui/LoadingOverlay";
import { RequirementCard } from "./RequirementCard";
import SelectableRequirementRow from "./SelectableRequirementRow";
import { NEW_REQUIREMENT, UNNEEDED_REQUIREMENT, NEW_REQUIREMENT_SUB_TITLE, UNNEEDED_REQUIREMENT_SUB_TITLE, DIFFERENT_FROM_TEMPLATE_REQUIREMENT_SUB_TITLE } from "./consts";
import { ButtonWrapper, RequirementsCompareWrapper, RequirementsCompareEmpty, RequirementsCompareSectionHeader } from "./style";
import { useMassagedRequirementDifferences } from "./useMassagedRequirementDifferences";
import { useUpdateRequirementDifferences } from "../../../data";
import { raiseSuccessMessage } from '@applyboard/ui-utils';
import handleApiErrorResponse from "../../../util/handleApiErrorResponse";
var renderEmptyRow = function renderEmptyRow() {
  return /*#__PURE__*/React.createElement(RequirementsCompareEmpty, null, /*#__PURE__*/React.createElement("span", {
    className: "empty"
  }, "None"));
};
var isDisabled = function isDisabled(newRequirements, unneededRequirements) {
  var result = true;
  if (newRequirements && unneededRequirements) {
    var requirements = newRequirements.concat(unneededRequirements);
    requirements.forEach(function (item) {
      if (item.checked) {
        result = false;
      }
    });
  }
  return result;
};
export var CompareRequirementsModal = function CompareRequirementsModal(_ref) {
  var applicationId = _ref.applicationId,
    onClose = _ref.onClose,
    open = _ref.open,
    onUpdateClickedOnAppReq = _ref.onUpdateClickedOnAppReq,
    onUpdateClickedOnActions = _ref.onUpdateClickedOnActions,
    tab = _ref.tab;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    newRequirements = _useState2[0],
    setNewRequirements = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    unneededRequirements = _useState4[0],
    setUnneededRequirements = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    modifiedRequirements = _useState6[0],
    setModifiedRequirements = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isNewRequirementChecked = _useState8[0],
    setIsNewRequirementChecked = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isUnneededRequirementChecked = _useState10[0],
    setIsUnneededRequirementChecked = _useState10[1];
  var _useUpdateRequirement = useUpdateRequirementDifferences(),
    updateRequirementDifferences = _useUpdateRequirement.updateRequirementDifferences;
  var _useMassagedRequireme = useMassagedRequirementDifferences(tab, applicationId),
    filteredNew = _useMassagedRequireme.filteredNew,
    filteredUnneeded = _useMassagedRequireme.filteredUnneeded,
    filteredMod = _useMassagedRequireme.filteredMod,
    isLoadingRequirementDifferences = _useMassagedRequireme.isLoadingRequirementDifferences,
    isFetchingRequirementDifferences = _useMassagedRequireme.isFetchingRequirementDifferences;
  var isLoading = isLoadingRequirementDifferences || isFetchingRequirementDifferences;
  var updateValues = function updateValues() {
    if (filteredNew) {
      setNewRequirements(filteredNew);
    }
    if (filteredUnneeded) {
      setUnneededRequirements(filteredUnneeded);
    }
    if (filteredMod) {
      setModifiedRequirements(filteredMod);
    }
    if (filteredNew.every(function (item) {
      return item.checked === true;
    })) {
      setIsNewRequirementChecked(true);
    } else {
      setIsNewRequirementChecked(false);
    }
    if (filteredUnneeded.every(function (item) {
      return item.checked === true;
    })) {
      setIsUnneededRequirementChecked(true);
    } else {
      setIsUnneededRequirementChecked(false);
    }
  };
  useEffect(function () {
    updateValues();
  }, [open, filteredNew, filteredUnneeded, filteredMod]);

  // handle selecting and unselecting of individual requirement checkboxes in compare modal
  var handleCheckRequirement = function handleCheckRequirement(e, type, requirementTitle) {
    // list of requirements that have been checked
    var checkedItems = [];
    var requirements = type === NEW_REQUIREMENT ? newRequirements : unneededRequirements;
    var targetChecked = e.target.checked;
    var checkedRequirements = requirements.map(function (item) {
      if (item.title === requirementTitle) {
        item.checked = targetChecked;
        // add item selected by user to list of checked requirements
        if (targetChecked && !checkedItems.includes(item.title)) {
          checkedItems.push(item.title);
        }
      }
      // add any automatically checked items to list of checked requirements
      if (item.checked && !checkedItems.includes(item.title)) {
        checkedItems.push(item.title);
      }
      return item;
    });
    if (type === NEW_REQUIREMENT) {
      if (!targetChecked) setIsNewRequirementChecked(false);
      if (checkedItems.length === newRequirements.length) {
        setIsNewRequirementChecked(true);
      }
      setNewRequirements(_toConsumableArray(checkedRequirements));
    } else {
      if (!targetChecked) setIsUnneededRequirementChecked(false);
      if (checkedItems.length === unneededRequirements.length) {
        setIsUnneededRequirementChecked(true);
      }
      setUnneededRequirements(_toConsumableArray(checkedRequirements));
    }
  };

  // handle selecting and unselecting of header checkboxes in compare modal
  var handleCheckAllRequirements = function handleCheckAllRequirements(e, type) {
    var requirements = type === NEW_REQUIREMENT ? newRequirements : unneededRequirements;
    var checkedRequirements = requirements.map(function (item) {
      item.checked = e.target.checked;
      return item;
    });
    if (type === NEW_REQUIREMENT) {
      setNewRequirements(_toConsumableArray(checkedRequirements));
      setIsNewRequirementChecked(!isNewRequirementChecked);
    } else {
      setUnneededRequirements(_toConsumableArray(checkedRequirements));
      setIsUnneededRequirementChecked(!isUnneededRequirementChecked);
    }
  };
  var onUpdateCompareRequirementsModal = function onUpdateCompareRequirementsModal() {
    // ids of the selected new/unneeded requirements to be updated upon clicking "update"
    var newRequirementIds = [];
    var unneededRequirementIds = [];
    newRequirements.forEach(function (item) {
      if (item.checked) newRequirementIds.push(item.requirementTemplateId);
    });
    unneededRequirements.forEach(function (item) {
      if (item.checked) unneededRequirementIds.push(item.applicationRequirementId);
    });
    updateRequirementDifferences({
      applicationId: applicationId,
      newRequirementIds: newRequirementIds,
      unneededRequirementIds: unneededRequirementIds
    }, {
      onSuccess: function onSuccess() {
        onClose();
        // upon clicking update in compare modal, set state variable to trigger removal of
        // counter notification on actions and/or app req tab
        if (tab.toLowerCase() === 'applicant requirements') {
          onUpdateClickedOnAppReq();
        } else if (tab.toLowerCase() === 'actions') {
          onUpdateClickedOnActions();
        }
        raiseSuccessMessage('Successfully Updated!');
      },
      onError: handleApiErrorResponse
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    title: "Requirement Comparison",
    maxWidth: "lg",
    handleClose: onClose,
    open: open
  }, isLoading && /*#__PURE__*/React.createElement(LoadingOverlay, null), /*#__PURE__*/React.createElement(RequirementsCompareWrapper, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RequirementsCompareSectionHeader, null, /*#__PURE__*/React.createElement(Checkbox, {
    id: "new-requirements-checkbox",
    checked: isNewRequirementChecked,
    onChange: function onChange(e) {
      return handleCheckAllRequirements(e, NEW_REQUIREMENT);
    },
    inputProps: {
      'aria-label': "Toggle new requirements"
    }
  }), /*#__PURE__*/React.createElement(CompareRequirementsModalHeader, {
    title: "New Requirements",
    subTitle: NEW_REQUIREMENT_SUB_TITLE
  })), newRequirements && newRequirements.length ? newRequirements.map(function (req) {
    return /*#__PURE__*/React.createElement(SelectableRequirementRow, {
      key: req.id,
      id: req.id,
      title: "".concat(req.requirementTemplateId || '', " ").concat(req.title),
      description: req.description,
      currentStage: req.currentStage,
      finalStage: req.finalStage,
      category: req.category,
      entityLevel: req.entityLevel,
      status: req.status,
      tags: req.tags,
      checked: req.checked,
      onChange: function onChange(e) {
        return handleCheckRequirement(e, NEW_REQUIREMENT, req.title);
      },
      isEarlyAccess: req.isEarlyAccess
    });
  }) : renderEmptyRow()), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RequirementsCompareSectionHeader, null, /*#__PURE__*/React.createElement(Checkbox, {
    id: "unneeded-requirements-checkbox",
    checked: isUnneededRequirementChecked,
    onChange: function onChange(e) {
      return handleCheckAllRequirements(e, UNNEEDED_REQUIREMENT);
    },
    inputProps: {
      'aria-label': "Toggle unneeded requirements"
    }
  }), /*#__PURE__*/React.createElement(CompareRequirementsModalHeader, {
    title: "Unnecessary Requirements",
    subTitle: UNNEEDED_REQUIREMENT_SUB_TITLE
  })), unneededRequirements && unneededRequirements.length ? unneededRequirements.map(function (req) {
    return /*#__PURE__*/React.createElement(SelectableRequirementRow, {
      key: req.id,
      id: req.id,
      title: "".concat(req.requirementTemplateId || '', " ").concat(req.title),
      description: req.description,
      currentStage: req.currentStage,
      finalStage: req.finalStage,
      category: req.category,
      entityLevel: req.entityLevel,
      status: req.status,
      tags: req.tags,
      checked: req.checked,
      onChange: function onChange(e) {
        return handleCheckRequirement(e, UNNEEDED_REQUIREMENT, req.title);
      },
      isEarlyAccess: req.isEarlyAccess
    });
  }) : renderEmptyRow()), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RequirementsCompareSectionHeader, null, /*#__PURE__*/React.createElement(CompareRequirementsModalHeader, {
    title: "Different from Template Requirements",
    subTitle: DIFFERENT_FROM_TEMPLATE_REQUIREMENT_SUB_TITLE
  })), modifiedRequirements && modifiedRequirements.length ? modifiedRequirements.map(function (req) {
    return /*#__PURE__*/React.createElement(RequirementCard, {
      key: req.id,
      id: req.id,
      title: "".concat(req.requirementTemplateId || '', " ").concat(req.title),
      description: req.description,
      currentStage: req.currentStage,
      finalStage: req.finalStage,
      category: req.category,
      entityLevel: req.entityLevel,
      status: req.status,
      tags: req.tags,
      modifiedAttributes: req.modifiedAttributes,
      isEarlyAccess: req.isEarlyAccess
    });
  }) : renderEmptyRow())), /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onUpdateCompareRequirementsModal,
    disabled: isDisabled(newRequirements, unneededRequirements)
  }, "Update")));
};
export var CompareRequirementsModalHeader = function CompareRequirementsModalHeader(_ref2) {
  var title = _ref2.title,
    subTitle = _ref2.subTitle;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    component: "h3"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, subTitle));
};